import React from 'react';
import Button from './Button.js';

/**
 * PrintDialog component - displays print options for orders
 * Shows four buttons: Print Receipt, Print Token, Print Both, No Print
 */
const PrintDialog = ({ isOpen, onClose, onSelectPrintMode }) => {
  if (!isOpen) return null;

  const handlePrintReceipt = () => {
    onSelectPrintMode('receipt');
    onClose();
  };

  const handlePrintToken = () => {
    onSelectPrintMode('token');
    onClose();
  };

  const handlePrintBoth = () => {
    onSelectPrintMode('both');
    onClose();
  };

  const handleNoPrint = () => {
    onSelectPrintMode('none');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-11/12 max-h-[90vh] overflow-auto">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Print Options</h2>
          <p className="text-gray-600 mt-2">Select what you want to print:</p>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handlePrintReceipt}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <span className="text-xl">🧾</span>
            Print Receipt
          </button>

          <button
            onClick={handlePrintToken}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <span className="text-xl">🎫</span>
            Print Token
          </button>

          <button
            onClick={handlePrintBoth}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <span className="text-xl">📋</span>
            Print Both
          </button>

          <button
            onClick={handleNoPrint}
            className="w-full bg-gray-400 hover:bg-gray-500 text-white font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <span className="text-xl">✕</span>
            No Print
          </button>
        </div>

        {/* Footer */}
        <div className="mt-6 pt-4 border-t border-gray-200 text-center text-sm text-gray-500">
          Select an option to proceed
        </div>
      </div>
    </div>
  );
};

export default PrintDialog;
